const ALL_SUBSCRIPTIONS = [
  'PLUS',
  'WEBSHOP',
  'BARCODE_SCANNER',
  'BOOKKEEPING',
  'CASH_REGISTER',
  'RESTAURANT',
  'ENKLA_ORDER',
  'FORTNOX_INVOICE',
  'PERSONALKOLLEN',
  'USER_PERMISSIONS',
  'RETAIL',
  'EXTERNAL_SEARCH',
];
const Subscriptions = {
  PLUS: 'PLUS',
  BARCODE_SCANNER: 'BARCODE_SCANNER',
  BOOKKEEPING: 'BOOKKEEPING',
  CASH_REGISTER: 'CASH_REGISTER',
  RESTAURANT: 'RESTAURANT',
  ENKLA_ORDER: 'ENKLA_ORDER',
  FORTNOX_INVOICE: 'FORTNOX_INVOICE',
  USER_PERMISSIONS: 'USER_PERMISSIONS',
  RETAIL: 'RETAIL',
};
const BookkeeperTypes = {
  fortnox: 'fortnox',
  visma: 'visma',
};

const RECURRING_TYPES = {
  NETS_TERMINAL: 'NETS_TERMINAL',
  SOFTPAY_FIRST_TERMINAL: 'SOFTPAY_FIRST_TERMINAL',
  SOFTPAY_TERMINAL: 'SOFTPAY_TERMINAL',
  TIDYPAY_TERMINAL: 'TIDYPAY_TERMINAL',
};

const USAGE_TYPES = {
  VIVA_PROVISION: 'VIVA_PROVISION',
  TEXT_MESSAGES: 'TEXT_MESSAGES',
};

export { ALL_SUBSCRIPTIONS, Subscriptions, BookkeeperTypes, RECURRING_TYPES, USAGE_TYPES };
